import React from "react";
import I18n from "../../../i18n";
import { Metrics } from "../../../theme/";
import Chart from "../../chart/";
import GraphCard from "../GraphCard";
import DataPercentList from "../../list/DataPercentList";
import { isFunction, isFillAlive } from "../../../util";
import { GraphDataMaker } from "../../../util/helper/graph";
import { getSplitRatio } from "./index";

export default ({
	header = "",
	onHeaderClick,
	data, previousData,
	height, 
	colorType,
	style, 
	showLegend = true, 
	// showColor = true,
	isVertical = false, 
	orderColor = true,
	removeZero = false,
	short = false,
	onClick,
	onLegendClick,
	onClickDataKey = "item",
	graphTextKey = "item",
	listTextKey = "item",
	translate = false,
	translator,
})=>{
	const mutateOnClick = isFunction(onClick) ? (select)=>onClick(select[onClickDataKey]) : undefined;
	const mutateOnLegendClick = isFunction(onLegendClick) ? (select)=>{onLegendClick(select.item);} : mutateOnClick;
	let pickData = data;
	let pickPrevioisData = previousData;
	if(translate){
		const tran = isFunction(translator) ? translator : (v)=>v[onClickDataKey].toLowerCase();
		if(isFillAlive(pickData)){
			pickData = GraphDataMaker.translateTargets(pickData, 
				tran, [graphTextKey, listTextKey]
			);
		}
		if(isFillAlive(pickPrevioisData)){
			pickPrevioisData = GraphDataMaker.translateTargets(pickPrevioisData, 
				tran, [graphTextKey, listTextKey]
			);
		}
	}
	return (<GraphCard 
		style={{...style, marginTop:Metrics.button.spaceMargin}} 
		header={header}
		onHeaderClick={onHeaderClick}
		height={height}
		isVertical = {isVertical}
		chartWidthRatio={getSplitRatio(short)}
		graph={
			<Chart.ColumnChart 
				labelKey={graphTextKey}
				valueKey='count'
				data={pickData} 
				orderColor={orderColor}
				visualColorKey={colorType}
				hideZero={removeZero}
				onClick={mutateOnClick}
			/>
		}
		legend={showLegend ? 
			<DataPercentList 
				percentDatas={pickData}
				compareDatas={pickPrevioisData}
				textKey={listTextKey} 
				valueKey='count'
				percentKey='percent'
				visualColorKey={colorType}
				showColor={orderColor}
				showValue={!short}
				onClick={mutateOnLegendClick}
			/> : undefined
		}
	/>
	);};


// WEBPACK FOOTER //
// ./src/components/report/generics/ReportColumnChart.js